module.exports = __webpack_public_path__ + "img/image03_sp.f8ee556c.jpg";